module.exports = __webpack_public_path__ + "img/walletBlack.c6a0fbff.png";